(function () {
    'use strict';

    a3_cabin_reports.factory('MemoFactory', MemoFactory);

    /**
     * @memberof CabinReports
     * @ngdoc factory
     * @name MemoFactory
     * @description 
     *   Add, Update, Delete and Get Memos.
     * @ngInject
     */
    function MemoFactory(FlightFactory, GroundDutyFactory, IndexedDBService, PaxInfoFactory, $q) {

        /**
         * Initialize the Memo
         * @memberof MemoFactory
         */
        function Memo() {
            this.Id = null;
            this.expired = false;
        }

        var objType = 'Memos';
        var objCallback = Memo;
        var memoReadDatesById = {};

        var service = {
            getMemosFromStorage: getMemosFromStorage,
            setMemosToStorage: setMemosToStorage,
            clearMemosFromStorage: clearMemosFromStorage,
            getMemosForFlight: getMemosForFlight,
            getStoredMemosIds: getStoredMemosIds,
            saveOneMemoToStorage: saveOneMemoToStorage,
            addMemoToStorage: addMemoToStorage,
            deleteMemoFromStorage: deleteMemoFromStorage,
            setMemosFromServer: setMemosFromServer,
            getMemosForGroundDuty: getMemosForGroundDuty,
            getMemosForCrewRoute: getMemosForCrewRoute,
            getUnreadMemos: getUnreadMemos,
            getMandatoryUnreadMemos: getMandatoryUnreadMemos,
            getAllUnreadGroundDutyMemos: getAllUnreadGroundDutyMemos,
            markGroundDutiesUnread: markGroundDutiesUnread,
            info: info,
            getNotHiddenMemos: getNotHiddenMemos
        };

        /**
         * Get Memos
         * @memberof MemoFactory
         * @param {function} callback  
         */
        function getMemosFromStorage(callback) {
            //return GenericService.list(objType,objCallback);
            IndexedDBService.getAll(objType).then(function (results) {
                callback(results);
            });
        };

        /**
         * Set Memos
         * @memberof MemoFactory
         * @param {array} Memos   a list of memos to set to indexedDB
         */
        function setMemosToStorage(Memos) {
            setDateOfIssueDefault(Memos);
            IndexedDBService.addAll(objType, Memos);
        };

        /**
         * Update Memo to Storage
         * @memberof MemoFactory
         * @param {object} Memo   a memo
         */
        function saveOneMemoToStorage(Memo) {
            setDateOfIssueDefault(Memo);
            IndexedDBService.put(objType, Memo);
        };

        function info() {
            IndexedDBService.info(objType);
        }

        /**
         * Add Memo to Storage
         * @memberof MemoFactory
         * @param {object} Memo   a memo
         */
        function addMemoToStorage(Memo) {
            setDateOfIssueDefault(Memo);
            IndexedDBService.add(objType, Memo);
        };

        /**
         * Delete Memo from Storage
         * @memberof MemoFactory
         * @param {number} MemoId  The unique Identifier of the Memo
         */
        function deleteMemoFromStorage(MemoId) {
            IndexedDBService.remove(objType, MemoId);
        };

        /**
         * Clear Memo from Storage
         * @memberof MemoFactory
         */
        function clearMemosFromStorage() {
            IndexedDBService.removeAll(objType);
        };

        function setDateOfIssueDefault(memos) {
            if (!memos) {
                return;
            }

            if (angular.isArray(memos)) {
                for (var i = 0; i < memos.length; i++) {
                    setDateOfIssueDefault(memos[i]);
                }
                return;
            }

            if (!memos.hasOwnProperty('DateOfIssue')) {
                memos.DateOfIssue = null;
            }
        }

        function ValidateCountryCategory(criteria, isDepartureCategory, isArrivalCategory) {
            var isValid = false;
            if (criteria.Special == "Specific") {
                isValid = ((criteria.Field == "Intra" && isDepartureCategory) || (criteria.Field == "Extra" && !isDepartureCategory))
                    && ((criteria.FieldOptional == "Intra" && isArrivalCategory) || (criteria.FieldOptional == "Extra" && !isArrivalCategory));
            }
            else {
                if (criteria.Field == "Intra") {
                    isValid = (isDepartureCategory && criteria.Special != "To") || (isArrivalCategory && criteria.Special != "From");
                }
                else if (criteria.Field == "Extra") {
                    isValid = (!isDepartureCategory && criteria.Special != "To") || (!isArrivalCategory && criteria.Special != "From");
                }
            }
            return isValid;
        }

        function isValid(field, departureField, arrivalField, special) {
            var isValid = false;

            var isDeparture = departureField == field;
            var isArrival = arrivalField == field;

            if (special == "From") {
                isValid = isDeparture
            } else if (special == "To") {
                isValid = isArrival;
            } else {
                isValid = isArrival || isDeparture;
            }

            return isValid;
        }

        /**
         * Gets all unread memos related to a Ground Duty
         * @memberof MemoFactory
         */
        function getAllUnreadGroundDutyMemos(callback) {
            getMemosFromStorage(function (results) {
                var memosCollection = results;
                var unreadGroundDutyMemos = [];
                for (var i = 0; i < memosCollection.length; i++) {
                    for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                        var item = memosCollection[i].MemoCriteria[j];
                        if (item.QueryType == "GroundDutyCode" && memosCollection[i].ReadDt == null) {
                            unreadGroundDutyMemos.push(memosCollection[i]);
                            break;
                        }
                    }

                }
                callback(unreadGroundDutyMemos);
            });
        }

        function getMemosForGroundDuty(Id, callback) {
            var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(Id);

            if (!groundDuty) {
                return [];
            }

            getMemosFromStorage(function (results) {
                var memosCollection = results;
                var groundDutyMemos = [];

                var fromDutyDate = new Date(groundDuty.DutyDate).getTime();
                var toDutyDate = new Date(groundDuty.DutyDate).getTime();

                for (var i = 0; i < memosCollection.length; i++) {

                    if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
                        for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                            var item = memosCollection[i].MemoCriteria[j];
                            if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuty.DutyNo || item.Field == groundDuty.GroundDutyNo)) {
                                groundDutyMemos.push(memosCollection[i]);
                                break;
                            }
                        }
                    }
                }
                callback(groundDutyMemos);
            });
        }
        /**
         * Get Memos that are relate to this flight
         * @memberof MemoFactory
         * @param {number} Id  The unique Identifier of the Memo
         * @param {function} callback  The callback function
         */
        function getMemosForFlight(Id, callback) {
            var flight = FlightFactory.getFlightFromStorage(Id);
            if (!flight) {
                flight = FlightFactory.getLocalFlightFromStorage(Id);
            }

            if (!flight) {
                return [];
            }

            getMemosFromStorage(function (results) {
                var memosCollection = results;
                var flightMemos = [];
                PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId, function (paxInfo) {
                    for (var i = 0; i < memosCollection.length; i++) {

                        if (new Date(memosCollection[i].ValidFrom).getTime() <= new Date(flight.ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() >= new Date(flight.ScheduledArrival).getTime()) {
                            for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                                var item = memosCollection[i].MemoCriteria[j];
                                if (
                                    (item.AcRegistration == flight.AcTailNo) ||
                                    (item.QueryType == "Airport" && isValid(item.Airport, flight.Departure, flight.Arrival, item.Special)) ||
                                    (item.FlightNo == flight.FlightNo) ||
                                    (item.AcType == flight.AcType) ||
                                    (isValidZone(item, flight.Zones)) ||
                                    (item.RouteStart == flight.Departure && item.RouteEnd == flight.Arrival) ||
                                    (item.ViceVersa && (item.RouteStart == flight.Arrival && item.RouteEnd == flight.Departure)) ||
                                    (item.QueryType == "Country" && isValid(item.Country, flight.DepartureCountry, flight.ArrivalCountry, item.Special)) ||
                                    (item.QueryType == "Schengen" && ValidateCountryCategory(item, flight.DepartureSchengen, flight.ArrivalSchengen)) ||
                                    (item.QueryType == "European" && ValidateCountryCategory(item, flight.DepartureEU, flight.ArrivalEU)) ||
                                    (paxInfo && (item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item))) ||
                                    (item.QueryType == "TrainingId" && item.Field == flight.TrainingIndicatorId)
                                ) {
                                    flightMemos.push(memosCollection[i]);
                                    break;
                                }
                            }
                        }
                    }
                    callback(flightMemos);
                });
            });
        }

        /**
         * Get Memos that are related to this crew route, by combining multiple flight and groundDuty memos 
         * @memberof MemoFactory
         * @param {number} DutyNo Crew Route Identifier
         * @param {number} DutyDay Crew Route Day
         * @param {function} callback  The callback function
         */
        function getMemosForCrewRoute(DutyNo, DutyDay, callback) {
            var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(DutyNo, DutyDay);
            var flights = FlightFactory.getFlightsByDutyNo(DutyNo, DutyDay);

            PaxInfoFactory.getAllPaxInfoFromStorage(function (paxInfoResult) {
                getMemosFromStorage(function (results) {
                    var memosCollection = results;
                    var allMemos = [];

                    for (var i = 0; i < memosCollection.length; i++) {
                        var inserted = false;
                        //first check if memo is connected with any groundDuties
                        for (var g = 0; g < groundDuties.length; g++) {
                            var fromDutyDate = new Date(groundDuties[g].DutyDate).getTime();
                            var toDutyDate = new Date(groundDuties[g].DutyDate).getTime();
                            if (new Date(memosCollection[i].ValidFrom).getTime() <= fromDutyDate && new Date(memosCollection[i].ValidTo).getTime() >= toDutyDate) {
                                for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                                    var item = memosCollection[i].MemoCriteria[j];
                                    if (item.QueryType == "GroundDutyCode" && (item.Field == groundDuties[g].DutyNo || item.Field == groundDuties[g].GroundDutyNo)) {
                                        allMemos.push(memosCollection[i]);
                                        inserted = true;
                                        break;
                                    }
                                }
                            }
                            if (inserted) break;    //don't check other groundDuties - memo is already inserted
                        }
                        //if memo was checked for all groundDuties and was not connected with any, check in flights
                        if (!inserted) {
                            for (var f = 0; f < flights.length; f++) {
                                var paxInfo = null;
                                if (new Date(memosCollection[i].ValidFrom).getTime() < new Date(flights[f].ScheduledDeparture).getTime() && new Date(memosCollection[i].ValidTo).getTime() > new Date(flights[f].ScheduledArrival).getTime()) {
                                    //check if flight has paxInfo 
                                    for (var p = 0; p < paxInfoResult.length; p++) {
                                        if (paxInfoResult[p].FlightId == flights[f].FlightId) {
                                            paxInfo = paxInfoResult[p];
                                            break;
                                        }
                                    }
                                    for (var j = 0; j < memosCollection[i].MemoCriteria.length; j++) {
                                        var item = memosCollection[i].MemoCriteria[j];
                                        if (
                                            (item.AcRegistration == flights[f].AcTailNo) ||
                                            (item.QueryType == "Airport" && isValid(item.Airport, flights[f].Departure, flights[f].Arrival, item.Special)) ||
                                            (item.FlightNo == flights[f].FlightNo) ||
                                            (item.AcType == flights[f].AcType) ||
                                            (isValidZone(item.Zone, flights[f].Zones)) ||
                                            (item.RouteStart == flights[f].Departure && item.RouteEnd == flights[f].Arrival) ||
                                            (item.ViceVersa && (item.RouteStart == flights[f].Arrival && item.RouteEnd == flights[f].Departure)) ||
                                            (item.QueryType == "Country" && isValid(item.Country, flights[f].DepartureCountry, flights[f].ArrivalCountry, item.Special)) ||
                                            (item.QueryType == "Schengen" && ValidateCountryCategory(item, flights[f].DepartureSchengen, flights[f].ArrivalSchengen)) ||
                                            (item.QueryType == "European" && ValidateCountryCategory(item, flights[f].DepartureEU, flights[f].ArrivalEU)) ||
                                            (paxInfo && (item.QueryType == "SsrCode" && PassengersHasSsrCode(paxInfo, item))) ||
                                            (item.QueryType == "TrainingId" && item.Field == flights[f].TrainingIndicatorId)
                                        ) {
                                            allMemos.push(memosCollection[i]);
                                            inserted = true;
                                            break;
                                        }
                                    }
                                }
                                if (inserted) break; //don't check other flights - memo is already inserted
                            }
                        }
                    }
                    callback(allMemos);
                });
            });

        }

        function PassengersHasSsrCode(paxInfo, memoCriterion) {
            var retVal = false;
            for (var key in paxInfo.PassengerSummaryY) {
                if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
                    retVal = true;
                    break;
                }
            }
            for (var key in paxInfo.PassengerSummaryX) {
                if (key === memoCriterion.Field && paxInfo.PassengerSummaryY[key] > 0) {
                    retVal = true;
                    break;
                }
            }
            return retVal;
        }

        /**
         * Check if the zone is valid
         * @memberof MemoFactory
         * @param {CriteriaZone} Zone from MemoCriteria
         * @param {FlightZones} List of Zones from flight
         */
        function isValidZone(CriteriaZone, FlightZones) {
            if (!CriteriaZone || CriteriaZone.Type != "Zone" || !FlightZones || FlightZones.length == 0) {
                return false;
            } else {
                // some is equivalent to Any()
                var zoneExist = FlightZones.some(function (item) {
                    return item.Title.toUpperCase() == CriteriaZone.Field.toUpperCase() && item.Class.toUpperCase() == CriteriaZone.FieldOptional.toUpperCase();
                });
                return zoneExist;
            }
        }

        /**
         * Get Stored Memos 
         * @memberof MemoFactory
         * @param {function} callback  The callback function
         */
        function getStoredMemosIds(callback) {
            getMemosFromStorage(function (memos) {
                var memoIds = [];
                memoReadDatesById = {};
                for (var i = 0; i < memos.length; i++) {
                    var memoIdRead = {
                        Id: memos[i].Id,
                        ReadDt: memos[i].ReadDt
                    }

                    if (!memos[i].hasOwnProperty('DateOfIssue')) {
                        memoReadDatesById[memos[i].Id] = memos[i].ReadDt;
                        continue;
                    }

                    memoIds.push(memoIdRead);
                }
                callback(memoIds);
            });
        }

        /**
         * set memos from server api  
         * @memberof MemoFactory
         * @param {array} memos  The memos 
         * @param {array} memoIdsToSend  The old memos of the storage
         * @param {string} lastSyncDate  The last Sync Date 
         */
        function setMemosFromServer(memos, memoIdsToSend, lastSyncDate) {
            var hasDateOfIssueBackfill = hasMemosPendingDateOfIssue();

            if (!hasDateOfIssueBackfill && (!lastSyncDate || !memoIdsToSend || memoIdsToSend.length == 0)) {
                setMemosToStorage(memos);
            } else {
                for (var j = 0; j < memos.length; j++) {
                    if (memoReadDatesById.hasOwnProperty(memos[j].Id)) {
                        memos[j].ReadDt = memos[j].ReadDt || memoReadDatesById[memos[j].Id];
                        memos[j].IsUpdated = true;
                        memos[j].IsNew = false;
                        saveOneMemoToStorage(memos[j]);
                        continue;
                    }

                    var IsMemoIncluded = false;

                    for (var h = 0; h < memoIdsToSend.length; h++) {
                        if (memos[j].Id == memoIdsToSend[h].Id) {
                            IsMemoIncluded = true;
                            break;
                        }
                    }

                    if (IsMemoIncluded) {
                        memos[j].IsUpdated = true;
                        memos[j].IsNew = false;
                        saveOneMemoToStorage(memos[j]);
                    } else {
                        memos[j].IsNew = true;
                        memos[j].IsUpdated = false;
                        addMemoToStorage(memos[j]);
                    }
                }
                memoReadDatesById = {};
            }
        }

        function hasMemosPendingDateOfIssue() {
            for (var memoId in memoReadDatesById) {
                if (memoReadDatesById.hasOwnProperty(memoId)) {
                    return true;
                }
            }

            return false;
        }

        /**
         * Get Unread Memos 
         * @memberof MemoFactory
         */
        function getUnreadMemos(callback) {
            getNotHiddenMemos(function (memos) {
                if (!memos)
                    return [];

                var arrayLength = memos.length;
                var result = [];

                for (var i = 0; i < arrayLength; i++) {
                    if (!memos[i].ReadDt) {
                        result.push(memos[i]);
                    }
                }
                callback(result);
            });
        }

        /**
         * Get Count of Unread Mandatory Memos
         * @memberof MemoFactory
         */
        function getMandatoryUnreadMemos(callback) {
            getNotHiddenMemos(function (memos) {
                if (!memos)
                    return [];

                var result = [];
                var arrayLength = memos.length;

                for (var i = 0; i < arrayLength; i++) {
                    if (!memos[i].ReadDt && memos[i].IsMandatory) {
                        result.push(memos[i]);
                    }
                }
                callback(result);
            });
        }

        /**
        * Flags Ground Duties if they have at least one unread memo
        * @memberof MemoFactory
        */
        function markGroundDutiesUnread() {
            getAllUnreadGroundDutyMemos(function (groundDutyMemos) {

                var groundDuties = GroundDutyFactory.getGroundDutiesFromStorage();

                if (groundDuties != null) {
                    for (var i = 0; i < groundDuties.length; i++) {
                        groundDuties[i].Unread = false;

                        //check if this ground duty has any unread ground duty memo
                        var fromDutyDate = new Date(groundDuties[i].DutyDate).getTime();
                        var toDutyDate = new Date(groundDuties[i].DutyDate).getTime();

                        for (var j = 0; j < groundDutyMemos.length; j++) {
                            if (new Date(groundDutyMemos[j].ValidFrom).getTime() <= fromDutyDate && new Date(groundDutyMemos[j].ValidTo).getTime() >= toDutyDate) {
                                for (var z = 0; z < groundDutyMemos[j].MemoCriteria.length; z++) {
                                    var item = groundDutyMemos[j].MemoCriteria[z];
                                    if ((item.Field == groundDuties[i].DutyNo || item.Field == groundDuties[i].GroundDutyNo)) {
                                        groundDuties[i].Unread = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                    GroundDutyFactory.setGroundDutiesToStorage(groundDuties);
                }
            });
        }


        /**
        * Exclude hidden memos from collection
        * @memberof MemoFactory
        */
        function getNotHiddenMemos(callback) {
            getMemosFromStorage(function (memos) {
                var result = [];
                if (memos) {
                    result = memos.filter(function (memo) {
                        return !memo.IsHidden;
                    });
                }
                callback(result);
            });
        }

        return service;
    }

})();
